import { render, staticRenderFns } from "./businessonebox-alloutbox.vue?vue&type=template&id=424d71f4&"
import script from "./businessonebox-alloutbox.vue?vue&type=script&lang=js&"
export * from "./businessonebox-alloutbox.vue?vue&type=script&lang=js&"
import style0 from "./businessonebox-alloutbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports